import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { canShowWebPurchase } from 'redux/modules/nativeApp';

export function useCanShowWebPurchase() {
  return useSelector(canShowWebPurchase);
}

/**
 * Renders purchase and upgrade surfaces (pricing links, Stripe Checkout and
 * Portal, credit packs, Boost, payments to freelancers) on the web only.
 * In the app they're hidden (Apple 3.1.1), or replaced by `fallback`.
 * TP-392 swaps this for the native paywall in one place.
 */
const WebOnly = ({ children, fallback }) =>
  useCanShowWebPurchase() ? children : fallback;

WebOnly.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node,
};

// React 16 can't render undefined, e.g. <WebOnly fallback={…} /> on the web.
WebOnly.defaultProps = {
  children: null,
  fallback: null,
};

export default WebOnly;
